import { GradientType } from '@ui/types'
import { colors as c } from '@ui/colors'
import { OptionColor } from '@order/steps/types'

export const optionTextColor: Record<OptionColor | 'default', string> = {
  default: c.text50,
  gray: c.gray[500],
  latte: c.latte[600],
  green: c.lime[600],
  magenta: c.magenta[600],
  blue: c.blue[600],
  bronze: c.tgbo.bronze1,
  silver: c.tgbo.silver1,
  gold: c.tgbo.gold1,
}

export const optionGradient: Record<OptionColor | 'default', GradientType> = {
  default: [c.text75, c.text],
  gray: [c.gray[500], c.gray[600], c.gray[800]],
  latte: [c.latte[500], c.latte[600], c.latte[800]],
  green: [c.lime[500], c.lime[600], c.lime[800]],
  magenta: [c.magenta[500], c.magenta[600], c.magenta[800]],
  blue: [c.blue[500], c.blue[600], c.blue[800]],
  bronze: [c.tgbo.bronze2, c.tgbo.bronze1],
  silver: [c.tgbo.silver2, c.tgbo.silver1],
  gold: [c.tgbo.gold2, c.tgbo.gold1],
}
